import { styled } from "@material-ui/core";

/**
 * @deprecated. You should be wrapping your page with the Page component
 * instead, and overriding any styles as necessary.
 */
const PageContent = styled("div")(({ theme }) => ({
  margin: `${theme.spacing(2)}px ${theme.spacing(1)}px`,
}));

export default PageContent;
